import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import { CheckCircle } from "lucide-react";
import "./homeLanding.css";

const HomeLanding = () => {
	const { language } = useContext(CombinedContext);
	const navigate = useNavigate();

	return (
		<div className="sf-homelanding-section1">
			{/* HERO */}
			<section className="sf-homelanding-hero">
				<h1>{translations[language].homeLanding.hero.title}</h1>
				<p>{translations[language].homeLanding.hero.subtitle}</p>

				<div className="sf-homelanding-hero-actions">
					<button
						className="btn brand"
						onClick={() => navigate("/businesslanding")}
					>
						{translations[language].homeLanding.hero.primaryCta}
					</button>

					<button
						className="btn outline"
						onClick={() => navigate("/barbershop")}
					>
						{translations[language].homeLanding.hero.secondaryCta}
					</button>
				</div>

				<p className="sf-homelanding-platforms">
					{translations[language].homeLanding.hero.platformText}
				</p>
			</section>

			{/* WHO WE ARE */}
			<section className="sf-homelanding-section">
				<h2>{translations[language].homeLanding.about.title}</h2>

				<p className="sf-homelanding-text">{translations[language].homeLanding.about.paragraph1}</p>
				<p className="sf-homelanding-text">{translations[language].homeLanding.about.paragraph2}</p>

				<p className="sf-homelanding-text strong">
					{translations[language].homeLanding.about.paragraph3}
				</p>
			</section>

			{/* WHAT WE DO */}
			<section className="sf-homelanding-section sf-homelanding-light">
				<h2>{translations[language].homeLanding.whatWeDo.title}</h2>
				<p className="sf-homelanding-text center">
					{translations[language].homeLanding.whatWeDo.description}
				</p>

				<div className="sf-homelanding-columns">
					{/* FOR BUSINESSES */}
					<div className="sf-homelanding-card">
						<h3>{translations[language].homeLanding.business.title}</h3>
						<p className="sf-homelanding-card-intro">
							{translations[language].homeLanding.business.intro}
						</p>

						<ul>
							{translations[language].homeLanding.business.items.map((item, idx) => (
								<li key={idx}>
									<CheckCircle size={18} /> {item}
								</li>
							))}
						</ul>

						<button
							className="btn brand small"
							onClick={() => navigate("/businesslanding")}
						>
							{translations[language].homeLanding.business.cta}
						</button>
					</div>

					{/* FOR CLIENTS */}
					<div className="sf-homelanding-card">
						<h3>{translations[language].homeLanding.clients.title}</h3>
						<p className="sf-homelanding-card-intro">
							{translations[language].homeLanding.clients.intro}
						</p>

						<ul>
							{translations[language].homeLanding.clients.items.map((item, idx) => (
								<li key={idx}>
									<CheckCircle size={18} /> {item}
								</li>
							))}
						</ul>

						<button
							className="btn outline small"
							onClick={() => navigate("/barbershop")}
						>
							{translations[language].homeLanding.clients.cta}
						</button>
					</div>
				</div>
			</section>

			{/* MINI CTA */}
			<section className="sf-homelanding-mini-cta">
				<p>{translations[language].homeLanding.finalCta.text}</p>

				<div className="sf-homelanding-store-row">
					<div className="sf-homelanding-store">App Store</div>
					<div className="sf-homelanding-store">Google Play</div>
				</div>
			</section>
		</div>
	);
};

export default HomeLanding;
